import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {DEFAULT_CMP_DELAY_MS} from 'app/utils/loadGroupCMP/constants';
import {shouldDelayCmp} from 'app/utils/loadGroupCMP/shouldDelayCmp';
import {CmpSettingsConfig} from 'interfaces/cmp/components/cmpSettingsConfig';

export function loadGroupCMP(gemSettings: GemSettings) {
    const cmpSettingsConfig = getGemSettingsFeature<CmpSettingsConfig>(gemSettings, 'cmp');
    if (!cmpSettingsConfig) {
        return;
    }

    if (shouldDelayCmp()) {
        setTimeout(() => mountGroupCmp(cmpSettingsConfig), DEFAULT_CMP_DELAY_MS);
        return;
    }

    mountGroupCmp(cmpSettingsConfig);
}

function mountGroupCmp(cmpSettingsConfig: CmpSettingsConfig) {
    const groupCmpScript = document.createElement('script');
    groupCmpScript.src = cmpSettingsConfig.scriptUrl;
    groupCmpScript.type = 'module';
    document.head.appendChild(groupCmpScript);

    const groupCmpWebComponent = document.createElement('gem-group-cmp');
    groupCmpWebComponent.setAttribute('banner-id', String(cmpSettingsConfig.bannerId));
    groupCmpWebComponent.setAttribute('cmp-endpoint', cmpSettingsConfig.cmpEndpoint);
    if (cmpSettingsConfig.googleConsentMode) {
        groupCmpWebComponent.setAttribute('google-consent-mode', JSON.stringify(cmpSettingsConfig.googleConsentMode));
    }

    document.body.appendChild(groupCmpWebComponent);
}
